import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Kody promocyjne',
  tabs: {
    active: 'Aktywne',
    expired: 'Wygasłe',
    email_sign_up: 'Promo kod przy rejestracji e-mail',
  },
  show_master_promo_code: 'Pokaż główny kod promocyjny klientom',
  send_rejected_order_apologies_promo_code: 'Wyślij kod promocyjny klientom przy ręcznym odrzuceniu zamówienia',
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Master',
        [PromoCodeTag.Campaign]: 'Kampania',
        [PromoCodeTag.OneTime]: 'Jednorazowy',
      },
    },
    code: {
      placeholder: 'Kod',
    },
    campaign: {
      placeholder: 'Kampania',
    },
    created_by: {
      placeholder: 'Utworzone przez',
      options: {
        [PromoCodeCreatedBy.User]: 'Użytkownik',
        [PromoCodeCreatedBy.System]: 'System',
      },
    },
  },
  fields: {
    code: 'Kod',
    tag: 'Tag',
    type: 'Typ',
    discount_type: 'Typ rabatu',
    discount: 'Rabat',
    usage_threshold: 'Próg użycia',
    quantity: 'Ilość',
    expires_at: 'Wygasa',
    level: 'Poziom',
    max_discount: 'Maks. rabat',
    created_by: 'Utworzone przez',
    image: 'Obraz',
  },
  tags: {
    [PromoCodeTag.Master]: 'Master',
    [PromoCodeTag.Campaign]: 'Kampania',
    [PromoCodeTag.OneTime]: 'Jednorazowy',
  },
  types: {
    single_use: 'Jednorazowy',
    multi_use: 'Wielokrotny',
    unknown: 'Nieznany',
  },
  discount_types: {
    fixed_amount: 'Stała kwota',
    percentage: 'Procent',
    unknown: 'Nieznany',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Użytkownik',
    [PromoCodeCreatedBy.System]: 'System',
  },
  labels: {
    discount: 'Rabat',
    usage_threshold: 'Próg użycia',
    company: 'Firma',
    restaurant: 'Restauracja',
    restaurant_group: 'Marka',
  },
  buttons: {
    add: 'Dodaj',
    edit: 'Edytuj',
    delete: 'Usuń',
    restore: 'Przywróć',
    add_promo_code: 'Dodaj kod promocyjny',
    images: 'Zarządzaj obrazem',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_save_settings: 'Nie udało się zapisać zmian',
    failed_to_delete_promo_code: 'Nie udało się usunąć kodu promocyjnego',
    failed_to_restore_promo_code: 'Nie udało się przywrócić kodu promocyjnego',
    promo_code_got_deleted: 'Kod promocyjny został usunięty',
    promo_code_got_restored: 'Kod promocyjny został przywrócony',
  },
  delete_confirmation: {
    title: 'Usunąć kod promocyjny?',
    buttons: {
      yes: 'Tak',
      no: 'Nie',
    },
  },
  restore_confirmation: {
    title: 'Przywrócić kod promocyjny?',
    buttons: {
      yes: 'Tak',
      no: 'Nie',
    },
  },
};
